import { Amplify } from 'aws-amplify';

export function configureAmplify() {
    const domain = process.env.REACT_APP_COGNITO_DOMAIN;

    Amplify.configure({
        Auth: {
            Cognito: {
                userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID!,
                userPoolClientId: process.env.REACT_APP_COGNITO_CLIENT_ID!,
                ...(domain && {
                    loginWith: {
                        oauth: {
                            domain,
                            scopes: ['openid', 'email', 'profile'],
                            redirectSignIn: [process.env.REACT_APP_COGNITO_REDIRECT_SIGNIN!],
                            redirectSignOut: [process.env.REACT_APP_COGNITO_REDIRECT_SIGNOUT!],
                            responseType: 'code' as const,
                            providers: ['Google' as const],
                        },
                    },
                }),
            },
        },
    });
}
